import { Controller } from 'stimulus';

export default class extends Controller {
  static outlets = ['ui--confirmation-dialog'];

  static values = {
    title: String,
    deleteUrl: String,
    message: String,
  };

  open() {
    this.uiConfirmationDialogOutlet.open({
      title: this.titleValue,
      deleteUrl: this.deleteUrlValue,
      message: this.messageValue,
    });
  }
}
